import React from "react";
import AmCharts from "@amcharts/amcharts3-react";
import PropTypes from "prop-types";
import ReactDOMServer from "react-dom/server";
import FuelTooltip from "./FuelTimeseriesTooltip";
import SmartTimeSeriesRenderer from "../SmartTimeSeriesRenderer";

const Combustible = ({ data, max, lang, volumeUnit }) => {
  let chartData = [];
  data = data.filter(d => d.TanquesCombustible !== null);

  // Colores para eventos
  let finesCarga = data.filter(u => u.Evento === 105 && u.Detalles === "Fin");
  let iniciosCarga = data.filter(
    u => u.Evento === 105 && u.Detalles === "Inicio"
  );
  let finesDescarga = data.filter(
    u => u.Evento === 106 && u.Detalles === "Fin"
  );
  let iniciosDescarga = data.filter(
    u => u.Evento === 106 && u.Detalles === "Inicio"
  );

  finesCarga.forEach(u => {
    u.color = "#2c3e50";
  });

  iniciosCarga.forEach(u => {
    u.color = "#00FF00";
  });

  finesDescarga.forEach(u => {
    u.color = "#2c3e50";
  });

  iniciosDescarga.forEach(u => {
    u.color = "#FF0000";
  });

  if (typeof data === "undefined" || data === null || data.length === 0) {
    chartData = [
      {
        Fecha: "2018-01-28 00:00:17",
        Volumen: 0
      }
    ];
  } else {
    chartData = data;
  }

  let config = {
    type: "serial",
    pathToImages: "https://cdn.amcharts.com/lib/3/images/",
    language: lang._code,
    addClassNames: true,
    categoryField: "Fecha",
    marginTop: 50,
    categoryAxis: {
      minPeriod: "1mm",
      parseDates: true
    },
    mouseWheelZoomEnabled: true,
    chartCursor: {
      cursorPosition: "mouse",
      cursorColor: "#F05A30",
      listeners: [],
      categoryBalloonDateFormat: "YYYY-MM-DDTHH:NN:SS"
    },
    graphs: [
      {
        id: "combustible",
        connect: true,
        title: "graph 1",
        valueField: "Volumen",
        hideBulletsCount: 0,
        bulletAlpha: 0,
        bulletColor: "#95a5a6",
        fillAlphas: 1,
        lineAlpha: 0,
        fillColors: "#2c3e50",
        fillColorsField: "color",
        balloonColor: "#181818",
        balloonFunction: data =>
          ReactDOMServer.renderToString(
            <FuelTooltip data={data.dataContext} lang={lang} />
          )
        //"balloonText": "[[globo]]"
      }
    ],
    chartScrollbar: {
      graph: "g5",
      gridAlpha: 0,
      color: "#888888",
      scrollbarHeight: 55,
      backgroundAlpha: 0,
      selectedBackgroundAlpha: 0.1,
      selectedBackgroundColor: "#888888",
      graphFillAlpha: 0,
      autoGridCount: true,
      selectedGraphFillAlpha: 0,
      graphLineAlpha: 0.2,
      graphLineColor: "#c2c2c2",
      selectedGraphLineColor: "#888888",
      selectedGraphLineAlpha: 1
    },
    valueAxes: [
      {
        id: "ValueAxis-1",
        title: volumeUnit,
        maximum: max,
        minimum: 0
      }
    ],
    balloon: {
      fillColor: "#181818",
      color: "#FFFFFF",
      fillAlpha: 0.9,
      offsetX: 0,
      offsetY: 0,
      pointerWidth: 10,
      fixedPosition: true
    },
    export: {
      enabled: true,
      menu: [
        {
          class: "export-main",
          format: "PNG"
        }
      ]
    },
    dataProvider: chartData
  };

  /*
    if (typeof cursorCallback !== 'undefined' && cursorCallback !== null) {
        config.chartCursor.listeners = [{
                "event": "moved",
                "method": cursorCallback
            }];
    }
    else {
        config.chartCursor.listeners = [];
    }
    */

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "100%"
      }}
      options={config}
    />
  );
};

const CombustibleChart = ({ data, max, lang, volumeUnit }) => (
  <SmartTimeSeriesRenderer
    chart={Combustible}
    data={data}
    max={max}
    lang={lang}
    volumeUnit={volumeUnit}
  />
);

CombustibleChart.propTypes = {
  data: PropTypes.array.isRequired,
  max: PropTypes.number.isRequired,
  lang: PropTypes.object.isRequired,
  volumeUnit: PropTypes.string.isRequired
};

export default CombustibleChart;



// WEBPACK FOOTER //
// ./src/charts/FuelTimeseries/FuelTimeseriesAmcharts.js